import React, { useEffect, useRef, useState } from "react";
import { Image } from "../../components/componentIndex";

const ProfilePhoto = ({ imgUrl, altText, className }) => {
    return (
        <div className="profile-photo">
            <Image imgUrl={imgUrl} altText={altText} className={className} />
        </div>
    )
};

export default ProfilePhoto;